// Live aggregated results of a poll / word-cloud game — anonymous counts.
// For the word-cloud game the correct word is highlighted whenever
// correctKey is present (teacher always; students after it closes).
// KEEP IN SYNC with the dashboard original.

const BAR_COLORS = ["#0080dc", "#43a047", "#fb8c00", "#8e24aa", "#e53935", "#00897b", "#f6bf26", "#5c6bc0", "#8d6e63", "#26a69a", "#7cb342", "#ec407a", "#5d4037", "#00acc1"];

const ActivityResults = ({ activity, votesLabel }) => {
    if (!activity) return null;

    if (activity.kind === "poll") {
        const total = Math.max(activity.totalVotes, 1);
        return (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {activity.options.map((option, index) => {
                    const count = activity.counts[option.key] || 0;
                    const pct = Math.round((count / total) * 100);
                    return (
                        <div key={option.key}>
                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.85rem", fontWeight: 600, marginBottom: 2 }}>
                                <span>{option.title}</span>
                                <span style={{ fontVariantNumeric: "tabular-nums" }}>{count} · {pct}%</span>
                            </div>
                            <div style={{ height: 12, borderRadius: 6, background: "rgba(0,0,0,0.08)", overflow: "hidden" }}>
                                <div style={{
                                    height: "100%",
                                    width: `${pct}%`,
                                    minWidth: count > 0 ? 8 : 0,
                                    background: BAR_COLORS[index % BAR_COLORS.length],
                                    borderRadius: 6,
                                    transition: "width 400ms ease",
                                }} />
                            </div>
                        </div>
                    );
                })}
                <div style={{ fontSize: "0.78rem", color: "rgba(0,0,0,0.55)" }}>{votesLabel}: {activity.totalVotes}</div>
            </div>
        );
    }

    // word-cloud game: the words with their pick counts
    return (
        <div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 10px", alignItems: "center", justifyContent: "center", padding: "8px 0" }}>
                {activity.options.map((option, index) => {
                    const count = activity.counts[option.key] || 0;
                    const isCorrect = activity.correctKey === option.key;
                    return (
                        <span
                            key={option.key}
                            style={{
                                fontWeight: 700,
                                fontSize: "0.95rem",
                                padding: "5px 14px",
                                borderRadius: 999,
                                background: isCorrect ? "#c8e6c9" : "rgba(0,0,0,0.06)",
                                border: isCorrect ? "2px solid #2e7d32" : "2px solid transparent",
                                color: isCorrect ? "#1b5e20" : BAR_COLORS[index % BAR_COLORS.length],
                            }}
                        >
                            {isCorrect ? "✓ " : ""}{option.title}
                            {count > 0 && (
                                <span style={{
                                    marginInlineStart: 6,
                                    fontSize: "0.75rem",
                                    background: "rgba(0,0,0,0.12)",
                                    borderRadius: 999,
                                    padding: "1px 7px",
                                    fontVariantNumeric: "tabular-nums",
                                }}>{count}</span>
                            )}
                        </span>
                    );
                })}
            </div>
            <div style={{ fontSize: "0.78rem", color: "rgba(0,0,0,0.55)" }}>{votesLabel}: {activity.totalVotes}</div>
        </div>
    );
};

export default ActivityResults;
